import React from 'react';
import { IonText } from '@ionic/react';
import TicketCard from './TicketCard';

interface IProps {
    tickets: any[];
}

const Tickets: React.FC<IProps> = (props) => {
    return (
        <>
            {Array.isArray(props.tickets) && props.tickets.map((ticket, index) => <TicketCard ticket={ticket} key={index} />)}
            {(!Array.isArray(props.tickets) || props.tickets.length === 0) && (
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '48px 24px', gap: '8px' }}>
                    <IonText color="medium" style={{ fontSize: '14px' }}>No tickets found</IonText>
                    <IonText color="medium" style={{ fontSize: '13px' }}>Pull to refresh</IonText>
                </div>
            )}
        </>
    );
};

export default Tickets;
